import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { buildQuery } from '@calendly/http-tools'

import { customDomainSelector } from 'selectors/custom_domain'
import { getOmniAuthPath } from 'services/authentication_service'
import { redirectToAuthorizeUrl } from 'actions/omniauth'

import { useBookingRedirect } from '../hooks/use_booking_redirect'
import { useTracking } from '../hooks/use_tracking'
import { SignUpButton } from '../styles'

export const OmniAuthButton = ({
  provider,
  children,
  email: encodedEmail,
  signupSource = 'booking_page_availability'
}) => {
  const dispatch = useDispatch()
  const track = useTracking()
  const { bookingRedirect } = useBookingRedirect()
  const { enabled: customDomainEnabled, default_domain: defaultDomain } = useSelector(customDomainSelector)
  const path = getOmniAuthPath(provider, 'signup', {
    email: undefined,
    booking_redirect: bookingRedirect,
    signup_source: signupSource,
    section: 'booking'
  })
  const signup = useCallback(() => {
    dispatch(redirectToAuthorizeUrl(
      path,
      () => track('CTA Clicked', { cta_text: 'msft_oauth', cta_key: 'booking_page_availability' })
    ))
  }, [path, dispatch, track])

  const query = buildQuery({
    provider,
    email: encodedEmail,
    section: 'booking',
    signup_source: signupSource,
    booking_redirect: bookingRedirect
  }, {
    addQueryPrefix: true
  })

  const props = customDomainEnabled
    ? { as: 'a', href: `${defaultDomain}/app/register_oauth_redirect${query}` }
    : { onClick: signup }

  return (
    <SignUpButton {...props}>
      {children}
    </SignUpButton>
  )
}
